import { useTours } from "../../Common/Hooks/useTours";
import { DriverTourRunner } from "./DriverTourRunner";

/** Shows the guided tour that is due on the current page, if any. Mounted once, in the app shell. */
export const TourHost = () => {
  const { activeTour, completeTour } = useTours();

  if (!activeTour) return null;

  return (
    <DriverTourRunner
      key={activeTour.id}
      tour={activeTour}
      onFinish={() => completeTour(activeTour.id)}
    />
  );
};
